import { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { ButtonGroup, InputBase, Paper } from '@mui/material'
import PropTypes from 'prop-types'
import { Button, Picto } from '~/components'
import { useCanEdit } from '~/hooks'
import { useRouteContext } from '~/routes'
import { bshSlice } from '~/store'
import { useGroupContext } from '../hooks'

const NewGroupOrProperty = (props) => {
  const { noPicto } = props
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const canEdit = useCanEdit()
  const { group, onGroupActive } =
    useGroupContext(NewGroupOrProperty.name, false) ?? {}
  const { product, subCategory } = useRouteContext(NewGroupOrProperty.name)
  const attached = useMemo(() => !!group, [group])

  const [name, setName] = useState('')

  const addGroup = useCallback(async () => {
    if (!name) return
    const { payload: result } = await dispatch(
      bshSlice.savePropertiesGroup({
        data: { owner: product ?? subCategory, name },
      })
    )
    setName('')
    setTimeout(() => {
      onGroupActive?.(
        Math.max.apply(
          null,
          result?.groups?.map(({ id }) => id)
        )
      )
    }, 100)
  }, [name, dispatch, product, subCategory, onGroupActive])

  const addProperty = useCallback(async () => {
    await dispatch(
      bshSlice.createCustomProperty({
        data: { owner: group, description: name },
      })
    )
    setName('')
  }, [dispatch, group, name])

  if (!canEdit) {
    return null
  }

  return (
    <Paper
      component="form"
      // elevation={0}
      sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        placeholder={t('properties-group.input.placeholder', {
          context: attached && 'property',
        })}
        inputProps={{ 'aria-label': 'search google maps' }}
        value={name}
        onChange={({ target: { value } }) => setName(value)}
      />
      <ButtonGroup>
        {attached && (
          <Button
            size="small"
            variant="outlined"
            sx={{
              display: 'inline-flex',
              justifyContent: 'flex-start',
              alignItems: 'baseline',
              gap: 1,
            }}
            onClick={() => addProperty()}
          >
            {!noPicto && <Picto letter="M" />}
            {t('property.add')}
          </Button>
        )}
        <Button
          size="small"
          variant="contained"
          sx={{
            display: 'inline-flex',
            justifyContent: 'flex-start',
            alignItems: 'baseline',
            gap: 1,
          }}
          onClick={() => addGroup()}
        >
          {t('properties-group.add')}
        </Button>
      </ButtonGroup>
    </Paper>
  )
}

NewGroupOrProperty.propTypes = {
  noPicto: PropTypes.bool,
}

export default NewGroupOrProperty
